export const PaymentCalendarSortableColumns = [
  {
    key: 'po_number',
    label: 'PO Number',
    isSorted: false,
    headerStyle: 'min-w-150px w-150px',
  },
  {
    key: 'po_date',
    label: 'PO Date',
    isSorted: true,
    headerStyle: 'min-w-100px w-100px',
  },
  {
    key: 'supplier_name',
    label: 'Supplier Name',
    isSorted: true,
    headerStyle: 'min-w-250px w-250px',
  },
  {
    key: 'company_name',
    label: 'Company',
    isSorted: true,
    headerStyle: 'min-w-150px w-150px',
  },
  {
    key: 'make_payment',
    label: 'Make Payment',
    isSorted: true,
    headerStyle: 'min-w-150px w-150px',
    style: 'justify-content-end',
    isColumnTotal: true,
  },
  {
    key: 'total_amount',
    label: 'Total Amount',
    isSorted: true,
    headerStyle: 'min-w-150px w-150px',
    style: 'justify-content-end',
    isColumnTotal: true,
  },
  {
    key: 'paid_amount',
    label: 'Paid Amount',
    isSorted: true,
    headerStyle: 'min-w-150px w-150px',
    style: 'justify-content-end',
    isColumnTotal: true,
  },
  {
    key: 'remaining_amount',
    label: 'Remaining Amount',
    isSorted: true,
    headerStyle: 'min-w-175px w-175px text-end',
    style: 'justify-content-end',
    isColumnTotal: true,
  },
]

export const PaymentListViewSortableColumns = [
  {
    key: 'schedule_payment_date',
    label: 'Schedule Date',
    isSorted: true,
    headerStyle: 'min-w-150px w-150px',
  },
  {
    key: 'po_number',
    label: 'PO Number',
    isSorted: false,
    headerStyle: 'min-w-150px w-150px',
  },
  {
    key: 'po_date',
    label: 'PO Date',
    isSorted: true,
    headerStyle: 'min-w-125px w-125px',
  },
  {
    key: 'supplier_name',
    label: 'Supplier Name',
    isSorted: true,
    headerStyle: 'min-w-250px w-250px',
  },
  {
    key: 'company_name',
    label: 'Company',
    isSorted: true,
    headerStyle: 'min-w-125px w-125px',
  },
  {
    key: 'make_payment',
    label: 'Make Payment',
    isSorted: true,
    headerStyle: 'min-w-150px w-150px',
    style: 'justify-content-end',
  },
  {
    key: 'total_amount',
    label: 'Total Amount',
    isSorted: true,
    headerStyle: 'min-w-150px w-150px',
    style: 'justify-content-end',
  },
  {
    key: 'paid_amount',
    label: 'Paid Amount',
    isSorted: true,
    headerStyle: 'min-w-150px w-150px',
    style: 'justify-content-end',
  },
  {
    key: 'remaining_amount',
    label: 'Remaining Amount',
    isSorted: true,
    headerStyle: 'min-w-175px w-175px text-end',
    style: 'justify-content-end',
  },
]
